import { render, staticRenderFns } from "./docenteHome.vue?vue&type=template&id=20302464&scoped=true"
import script from "./docenteHome.vue?vue&type=script&lang=js"
export * from "./docenteHome.vue?vue&type=script&lang=js"
import style0 from "./docenteHome.vue?vue&type=style&index=0&id=20302464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20302464",
  null
  
)

export default component.exports